const subUsersValidationEN = {
    "add": {
        "first_name": {
            "required": "First name is required"
        },
        "last_name": {
            "required": "Last name is required"
        },
        "email": {
            "required": "Email is required",
            "invalid": "Email is not valid",
            "unique": "Email is associated with another user"
        },
        "username": {
            "required": "Username is required",
            "stringCaseLower": "Username must be in lowercase",
            "regexp": "Username must consist of letters and numbers only",
            "unique": "Username is associated with another user",
            "invalid": "Username is not valid"
        },
        "password": {
            "required": "Password is required",
            "regexp": "Password must consist of at least 10 characters, including 1 uppercase letter and 1 special character"
        },
        "confirmPassword": {
            "required": "Please confirm password",
            "identical": "Password and confirm password values must match"
        },
        "contract_expiry": {
            "required": "Contract expiry date is required"
        },
        "sub_user_deal": {
            "required": "Subuser deal is required",
            "between": "Subuser deal must be between 0 and 100"
        },
        "street_and_number": {
            "required": "Street and house number is required"
        },
        "postal_code": {
            "required": "Postal code is required"
        },
        "city": {
            "required": "City is required"
        },
        "country": {
            "required": "Country is required"
        },
        "phone": {
            "required": "Phone number is required"
        }
    },
    "update": {
        "first_name": {
            "required": "First name is required"
        },
        "last_name": {
            "required": "Last name is required"
        },
        "email": {
            "required": "Email is required",
            "invalid": "Email is not valid",
        },
        "username": {
            "required": "Username is required",
            "stringCaseLower": "Username must be in lowercase",
            "regexp": "Username must consist of letters and numbers only"
        },
        "contract_expiry": {
            "required": "Contract expiry date is required"
        },
        "sub_user_deal": {
            "required": "Subuser deal is required",
            "between": "Subuser deal must be between 0 and 100"
        },
        "street_and_number": {
            "required": "Street and house number is required"
        },
        "postal_code": {
            "required": "Postal code is required"
        },
        "city": {
            "required": "City is required"
        },
        "country": {
            "required": "Country is required"
        },
        "phone": {
            "required": "Phone number is required"
        }
    },
};
export default subUsersValidationEN;